import { dashboardDetailsConstants } from "../constants";

export function dashboardDetail(state = {}, action) {
  switch (action.type) {
    case dashboardDetailsConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool
      };
    case dashboardDetailsConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case dashboardDetailsConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.data,
        loading: false
      };
    case dashboardDetailsConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}
